export default "__VITE_ASSET__e157e60f__"